import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserActivationLinkIm } from '../platform-user-activation-link-im.model';
import { IPlatformUserActivationLinkVm } from '../platform-user-activation-link-vm.model';
@Injectable({ providedIn: 'root' })
export class PlatformUserActivationLinkService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserActivationLink`;
  }
  post(platformUserActivationLinkIm: IPlatformUserActivationLinkIm): Observable<IPlatformUserActivationLinkVm> {
    const headers = this.createHeaders();
    return this.http.post<IPlatformUserActivationLinkVm>(this.baseUrl, platformUserActivationLinkIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
